module.exports = __webpack_public_path__ + "img/QF.72f2dc80.png";